export default __webpack_public_path__ + "static/media/ro_logo_desk.bbab39df.svg";